import { Box, Button, Checkbox, FormControl, IconButton, Input, InputAdornment, InputLabel, TextField, Typography } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, loginFlagOff, loginWithFacebook, loginWithGoogle } from "../../redux/actions/User";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import Circularbar from "../../components/circularbar/Circularbar";
import { useTranslation } from "react-i18next";
import { api, baseApi } from "../../api/endpoints";
import { signInWithPopup } from "firebase/auth";
import { fbAuth, provider } from "../../firbaseConfig";

function ADuserLogin({aduseremail}) {


    const [searchParams, setSearchParams] = useSearchParams()
    const [loginMessage, setLoginMessage] = useState('Loading...')

    // const login = async (e) => {
    //     console.log(e)
    //     e.preventDefault()
    //         try {
    //             const res = await api.post('/user/adLogin', {email: e.target[0].value, otp: e.target[2].value})
        
    //             if(res.status == 200){
    //                 window.localStorage.setItem("isLogin", true);
    //                 window.location.reload()
    //             }else{
    //                 alert("Login failed")
    //             }
    //         } catch (error) {
    //             alert("Login failed")
    //         }  
    // }

    useEffect(() => {
        const login = async () => {
            if(searchParams.get('userId') && searchParams.get('otp')){
                try {
                    const res = await api.post('/user/adLogin', {userId: searchParams.get('userId'), otp: searchParams.get('otp')})
                    if (res.status == 200){
                        window.localStorage.setItem("isLogin", true);
                        window.localStorage.setItem("adUserAccountPreview", true)
                        window.localStorage.setItem("adEmail", aduseremail)
                        window.location.reload()
                    }else{
                        setLoginMessage('Error') 
                    }
                } catch (error) {
                    setLoginMessage('Error')
                }
            } else{
                setLoginMessage('No required params')
            }
        }
        login()
    }, [])

  return (
    <Box sx={{
        width: '300px',
        margin: '50px auto',
    }}>
        <Typography variant="h3" textAlign="center">{loginMessage}</Typography>
    </Box>
  );
}

export default ADuserLogin;
